import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chronosphere = defineConnector({
  identifier: "chronosphere",
  name: "Chronosphere",
  tagLine: "Cloud-native observability platform",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: ({ companyName }) =>
    `https://${companyName || ".*"}\\.chronosphere\\.io/.*`,
  auth: (app) => headerAuth([{ name: "API-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Chronosphere](https://chronosphere.io/), go to **Settings → API Tokens** and create a new service account token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Company name",
          required: true,
          target: { kind: "configuration", field: "companyName" },
          helperText:
            "Your Chronosphere subdomain (e.g., `acme` from `acme.chronosphere.io`).",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ companyName }) =>
      `https://${companyName}/api/v1/config/collections`,
  },
});
